import React from "react";
import { ModalHeader } from "nvs-design-system/dist/Modals/RoundedModal/components/ModalHeader";
import { ModalBody } from "nvs-design-system/dist/Modals/RoundedModal/components/ModalBody";
import TokenTransferStep, {
  TokenTransferStepProps,
} from "../../TokenTransferStep";
import FAQsLink from "../../FAQsLink";
import { Body5 } from "@/src/components/typography/components/Body";
import ReceivingAddressInput from "./ReceivingAddressInput";

export default function ReceivingAddress({
  isShowing = false,
  onContinue,
}: TokenTransferStepProps) {
  return (
    <TokenTransferStep isShowing={isShowing}>
      <ModalHeader>Receiving Address</ModalHeader>

      <ModalBody className="flex flex-col gap-6">
        <BodyCopy />

        <ReceivingAddressInput onContinue={onContinue}>
          <FAQsLink />
        </ReceivingAddressInput>
      </ModalBody>
    </TokenTransferStep>
  );
}

function BodyCopy() {
  return (
    <Body5>
      Enter the wallet address you wish to send your Nike Virtual Creation to. ENS addresses are not supported.
    </Body5>
  );
}
